/* eslint-disable react-hooks/exhaustive-deps */
import _ from "lodash";
import React, { Fragment, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import { Pagination } from "../../components/Pagination";
import Search from "../../components/Search";

import { useTranslation } from "react-i18next";
import { PerPage } from "../../components/PerPage";
import { LanguageConfig } from "../../config/Config";
import { useNotification } from "../../context/notification";
import { apiRequest } from "../../utils/api";
import styles from "./Teams.module.scss";

const CampaignTable = ({
  isCampaign,
  perPage,
  setPerPage,
  selectedCampaign,
  ...props
}) => {
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
  const { addNotification } = useNotification();
  const [totalData, setTotalData] = useState(0);
  const [offset, setOffset] = useState(1);
  const [searchKey, setSearchKey] = useState("");
  const [searchInputValue, setSearchInputValue] = useState("");
  const [teamData, setTeamData] = useState(null);

  const [columnName, setColumnName] = useState("u_fullname");
  const [sortOrder, setSortOrder] = useState("asc");
  const tableHeader = props.tableHeader;

  const handlePaginationChange = offset => {
    setOffset(offset.selected + 1);
  };

  // useEffect(() => {
  //   fetchData(searchKey);
  // }, [selectedCampaign, searchKey, offset, columnName, sortOrder, perPage]);

  //get the search key and data from location state
  useEffect(() => {
    if (location.state && location.state.searchKey) {
      console.log("location.state.searchKey", location.state);
      setSearchInputValue(location.state.searchKey);
      setSearchKey(location.state.searchKey);
      fetchData(location.state.searchKey);
      location.state = {};
      console.log("location.state", location.state);
    } else {
      fetchData(searchKey);
    }
  }, [
    location.state,
    selectedCampaign,
    searchKey,
    offset,
    columnName,
    sortOrder,
    perPage,
  ]);

  /*enhancement based on performance review, handling pagination from backend */
  async function fetchData(key) {
    console.log("key", key);
    const response = await apiRequest.get(
      `/api/getCampaignManagerCoachCoacheeDetails?campaign_id=${selectedCampaign}&type=campaign&page=${offset}&limit=${perPage}&columnName=${columnName}&order=${sortOrder}&search=${key}`
    );

    if (response.status === 200) {
      const data = response.data;
      const teamsList = data.data.coach_coachee_details;
      setTotalData(data.totalData);
      setTeamData(teamsList);
    } else {
      addNotification(
        t("error.couldNotGetSession") + ` (Status code: ${response.status})`,
        "error"
      );
    }
  }

  const sortData = name => {
    setColumnName(name);
    const order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);
  };

  //render table child heading data
  const tableChildHeader = language => {
    return language && language === LanguageConfig["Hong Kong"] ? (
      <TableRow>
        <TableCell>{t("sessionList.coachee")}</TableCell>
        <TableCell>{t("teams.employeeId")}</TableCell>
        <TableCell>{t("teams.department")}</TableCell>
        <TableCell>{t("teams.lastSession")}</TableCell>
        <TableCell>{t("teams.upcommingSession")}</TableCell>
      </TableRow>
    ) : (
      <TableRow>
        <TableCell>Coachees</TableCell>
        <TableCell>Employee Id</TableCell>
        <TableCell>Department</TableCell>
        <TableCell>Last Session</TableCell>
        <TableCell>Upcoming Session</TableCell>
      </TableRow>
    );
  };

  function Row(props) {
    const { row } = props;
    const [open, setOpen] = useState(false);
    return (
      <React.Fragment>
        <TableRow
          className={`${styles.tableRow} ${open ? styles.openRow : ""}`}
        >
          <TableCell
            className={`${open ? styles.openRow : ""}`}
            onClick={() => {
              // history.push(
              //   `/teams/details/${row.uid}?campaign=true${searchParams}`,
              // );
              history.push({
                pathname: `/teams/details/${row.uid}?campaign=true`,
                state: {
                  searchKey: searchKey,
                  teamData: teamData,
                  path: `/teams/campaign`,
                },
              });
            }}
          >
            {row.coach}
          </TableCell>
          <TableCell className={`${open ? styles.openRow : ""}`}>
            {row.employee_id}
          </TableCell>
          <TableCell className={`${open ? styles.openRow : ""}`}>
            {row.department}
          </TableCell>
          <TableCell className={`${open ? styles.openRow : ""}`}>
            {row.sub_functional_unit}
          </TableCell>
          <TableCell className={`${open ? styles.openRow : ""}`}>
            {row.last_session}
          </TableCell>
          <TableCell className={`${open ? styles.openRow : ""}`}>
            {" "}
            {row.upcoming_session}{" "}
          </TableCell>
          <TableCell className={`${open ? styles.openRow : ""}`}>
            {" "}
            {row.total_coachees}{" "}
          </TableCell>
          <TableCell className={`${open ? styles.openRow : ""}`}>
            {row.coachees && row.coachees.length > 0 && (
              <IconButton
                aria-label="expand row"
                size="small"
                style={{ outline: "none" }}
                onClick={e => {
                  e.stopPropagation();
                  setOpen(!open);
                }}
              >
                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </IconButton>
            )}
          </TableCell>
        </TableRow>
        <TableRow className={styles.tableDetailsRow}>
          <TableCell
            style={{ padding: "0", borderBottomWidth: open ? "1px" : 0 }}
            colSpan={8}
          >
            <Collapse
              in={open}
              timeout="auto"
              style={{
                padding: "16px 30px",
                overflow: "hidden",
                marginTop: "-22px",
              }}
              unmountOnExit
            >
              <TableContainer component={Paper} elevation={0}>
                <Table aria-label="Team" className={styles.subTable}>
                  <TableHead className={styles.tableHead}>
                    {tableChildHeader(localStorage.i18nextLng)}
                  </TableHead>
                  <TableBody>
                    {row.coachees &&
                      row.coachees.map((subRow, index) => (
                        <TableRow
                          onClick={() => {
                            // history.push(`/teams/details/${subRow.coachee_id}`);
                            history.push({
                              pathname: `/teams/details/${subRow.coachee_id}`,
                              state: {
                                searchKey: searchKey,
                                teamData: teamData,
                                path: `/teams/campaign`,
                              },
                            });
                          }}
                          key={index}
                        >
                          <TableCell className={styles.subTableRow}>
                            {subRow.coachee}
                          </TableCell>
                          <TableCell className={styles.subTableRow}>
                            {subRow.employee_id}
                          </TableCell>
                          <TableCell className={styles.subTableRow}>
                            {subRow.department}
                          </TableCell>
                          <TableCell className={styles.subTableRow}>
                            {subRow.last_session}
                          </TableCell>
                          <TableCell className={styles.subTableRow}>
                            {subRow.upcoming_session}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  return (
    <Fragment>
      <Search
        searchInputValue={searchInputValue}
        handleSearch={val => {
          setSearchKey(val);
          setOffset(1);
        }}
      />
      <TableContainer component={Paper} elevation={0}>
        <Table aria-label="Team" className={styles.table}>
          <TableHead className={styles.tableHead}>
            <TableRow>
              {tableHeader.map((tableHead, index) => (
                <TableCell
                  key={index}
                  className={styles.tableHeadCell}
                  onClick={() => {
                    sortData(tableHead.name);
                  }}
                  style={{ padding: "14px 10px", width: tableHead.width }}
                >
                  {tableHead.label}
                  {columnName === tableHead.name && sortOrder === "asc" && (
                    <span>
                      <KeyboardArrowUpIcon fontSize="small" />
                    </span>
                  )}
                  {columnName === tableHead.name && sortOrder === "desc" && (
                    <span>
                      <KeyboardArrowDownIcon fontSize="small" />
                    </span>
                  )}
                </TableCell>
              ))}
              <TableCell style={{ width: "3%" }}></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {teamData &&
              teamData.map((row, index) => (
                <Row key={row.session_id} row={row} />
              ))}
            {_.isEmpty(teamData) && (
              <TableRow style={{ borderBottom: "1px solid #eeeeee" }}>
                <TableCell style={{ borderBottom: 0 }} colSpan={7}>
                  {t("common.noRecordFound")}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {totalData > perPage && (
        <div className={styles.footer}>
          <PerPage limit={perPage} setLimit={setPerPage} />
          <Pagination
            totalData={totalData}
            limit={perPage}
            offset={offset}
            handlePageClick={offset => {
              handlePaginationChange(offset);
            }}
          />
        </div>
      )}
    </Fragment>
  );
};

export default CampaignTable;
